import ScopeConstants from "constants/ScopeConstants"

export const ProjectFinancialScope = {
    key: ScopeConstants.PROJECT_FINANCIAL,
    selector: (state) => state.projectFinancial,
    tokenSelector: (state) => state.authentication.token,
    singleEndpoint: "/api/Project/GetFinancial/",
}